import React from 'react';
import LargeButton from '../../../components/LargeButton';
import t from '../../../helpers/t';
import { $ } from '../../../../../vendor';

const SalesBillingsSidebar = (props) => {

    const addSalesBillingsHandler = (value) => {
        console.log("val: ",value);
    };

    const onToggleLeftBar = (ev) => {

        $('#inb-c-sidebar').toggleClass('open');
        $('html,body').scrollTop(0);
    };

    return (
        <aside
            id="inb-c-sidebar"
            className="filemanager-sidebar"
            style={{float:'left'}}>
            <header className="inb-c-left-bar__title">
                <h1 className="inb-page-title">
                {props.heading}
                </h1>
            </header>

            <footer className="inb-c-left-bar__footer small-only-float-container center-on-content">
                <a href="#"
                    id="toggle-left-bar"
                    className="button secondary show-for-small-only" onClick={(e) => onToggleLeftBar(e)}>
                        <i className="fi fi-filter"></i>
                        <span className="show-for-sr">{t('open_filter_menu')}</span>
                </a>
                <LargeButton
                    link="finances/sales_billings/add"
                    beautify={true}
                    icon="fi fi-page-add"
                    title={t('create_${a}',{a:t('sales_billing')})}
                    name="add-sales-billings"
                    handler={addSalesBillingsHandler}/>
            </footer>
        </aside>
    );
};

export default SalesBillingsSidebar;